// extracted by mini-css-extract-plugin
export default {"button":"notification-center-module--button--67bca","wrapper":"notification-center-module--wrapper--0a754","notificationList":"notification-center-module--notification-list--9fc17"};